<template>
  <!--
    	作者：wangxw
    	时间：2019-11-05
    	描述：diy组件 搜索栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!-- 背景颜色 -->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
      <!--组件高度-->
      <el-form-item label="组件高度：">
        <el-slider v-model="curItem.style.height" :min="1" :max='200' show-input></el-slider>
      </el-form-item>
      <el-form-item label="列表：">
        <draggable class="wrapper" v-model="localData" :options="{ animation: 120, filter: '.drag__nomove' }">
          <div class="param-img-item" :key="index" v-for="(item, index) in localData">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="onEditorDeleleData(index)"></i>
            </div>
            <el-form-item label="名称：">
              <el-input v-model="item.name"></el-input>
            </el-form-item>
            <el-form-item label="数量：">
              <el-input v-model="item.quantity"></el-input>
            </el-form-item>
          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
    </el-form>
   </div>
</template>

<script>
  import draggable from "vuedraggable";

  export default {
    data() {
      return {
        localData: []
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    components: {
      draggable
    },
    watch: {
      localData: {
        handler(newVal) {
          this.$set(this.curItem, 'data', newVal);
        },
        deep: true
      }
    },
    mounted() {
      if (this.curItem.data && this.curItem.data.length > 0) {
        this.localData = [...this.curItem.data];
      } else {
        this.localData = [{
          name: '',
          quantity: 1
        }];
        this.$set(this.curItem, 'data', this.localData);
      }
    },
    methods: {
      onEditorAddData() {
        this.localData.push({
          name: '',
          quantity: 1
        });
      },
      onEditorDeleleData(index) {
        if (this.localData.length <= 1) {
          this.$message({
            message: "至少保留一个",
            type: "error",
          });
          return false;
        }
        this.localData.splice(index, 1);
      }
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Shili.vue